import React, { useState } from 'react';
import ConsultationModal from '../../components/ConsultationModal';
import img16 from '../../img/16.png';

function CustomHairSystems() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <section className="page-hero">
        <div className="absolute inset-0 z-0">
          <img
            src={img16}
            alt="Custom hair system result"
            className="h-full w-full object-cover object-top opacity-40"
          />
          <div className="page-hero-scrim" />
        </div>
        <div className="container relative z-10 mx-auto px-4">
          <p className="section-kicker text-primary-200">Personalized design</p>
          <h1 className="font-display text-5xl font-semibold md:text-6xl">Custom Hair Systems</h1>
          <p className="mt-5 max-w-2xl text-xl text-white/85">
            Systems designed around your coverage needs, density, texture, color, and daily routine.
          </p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid gap-12 md:grid-cols-2">
            <div>
              <p className="section-kicker">Our process</p>
              <h2 className="section-heading">Built to look like your hair</h2>
              <p className="mb-6 leading-relaxed text-ink-muted">
                Each system is crafted to your specifications for a natural look and comfortable wear.
              </p>
              <ul className="space-y-4">
                {[
                  'Hair texture selection',
                  'Color matching',
                  'Density and length preferences',
                  'Base design and materials',
                ].map((item) => (
                  <li key={item} className="border-t border-primary-100 pt-4 text-ink-soft">
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-surface p-8">
              <h2 className="font-display text-3xl font-semibold text-ink">System options</h2>
              <div className="mt-6 space-y-6">
                <div className="border-b border-primary-100 pb-5">
                  <h3 className="text-xl font-semibold">Premium System</h3>
                  <ul className="mt-2 space-y-1 text-ink-muted">
                    <li>100% European human hair</li>
                    <li>Ultra-thin skin base</li>
                    <li>Invisible hairline</li>
                    <li>6-8 months longevity</li>
                  </ul>
                </div>
                <div className="pb-2">
                  <h3 className="text-xl font-semibold">Standard System</h3>
                  <ul className="mt-2 space-y-1 text-ink-muted">
                    <li>Premium human hair</li>
                    <li>Comfortable base</li>
                    <li>Natural appearance</li>
                    <li>4-6 months longevity</li>
                  </ul>
                </div>
                <button
                  type="button"
                  onClick={() => setIsModalOpen(true)}
                  className="w-full rounded-full bg-primary-600 px-6 py-3 font-semibold text-white transition duration-300 hover:bg-primary-700"
                >
                  Schedule Consultation
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ConsultationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        interest="Custom Hair Systems"
      />
    </div>
  );
}

export default CustomHairSystems;
